import { SEVERITY } from "helpers/utils.js";
import {
  GET_CUTTINGS,
  GET_CUTTINGS_SUCCESS,
  GET_CUTTING_BY_ID_SUCCESS,
  GET_CUTTINGS_ERROR,
  CUTTING_CLEAR_ERROR,
  GET_CUTTING_BY_ID,
  ADD_NEW_CUTTING,
  UPDATE_CUTTING,
  DELETE_CUTTING,
  GET_CUTTING_ENTRY_FORM_SUCCESS,
  GET_CUTTING_ENTRY_FORM,
  SAVE_CUTTING_ENTRY_FORM_SUCCESS,
  SAVE_CUTTING_ENTRY_FORM,
} from "./actionTypes.js"
const initState = {
  items: [],
  item: null,
  clothingSizes: [],
  summary: null,
  purchaseOrderItems: [],
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const cutting = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUTTING_ENTRY_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };
      
    case GET_CUTTING_ENTRY_FORM:
    case SAVE_CUTTING_ENTRY_FORM:
    case DELETE_CUTTING:
    case UPDATE_CUTTING:
    case GET_CUTTINGS:
      return {
        ...state,
        loading: true,
        // item: null,
      };
    case GET_CUTTINGS_SUCCESS:
      const { itemCount, pageCount, data, clothingSizes, purchaseOrderItems, summary } =
        payload;
      return {
        ...state,
        itemCount,
        pageCount,
        clothingSizes,
        purchaseOrderItems,
        summary,
        items: data,
        // item: null,
        loading: false,
      };
      
    case SAVE_CUTTING_ENTRY_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        message: {
          title: "Cutting Form",
          text: "Cutting Entries have been saved successfully",
          severity: SEVERITY.SUCCESS,
        },
      }
    case ADD_NEW_CUTTING:
      return {
        ...state,
        item: null,
      };
    case GET_CUTTING_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_CUTTING_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_CUTTINGS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case CUTTING_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default cutting;
